module.exports = __webpack_public_path__ + "media/images/dashboard/leaderboard-top-44a32b046e3f1b57294e9ab787428c8c.png";